
export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Edit Address',
        setAsDefault: 'Set as default delivery address',
        cancel: 'Cancel',
        confirm: 'Use This Address'
    };

    return resources[label];
}
